import { defineMessages } from "react-intl";

export default defineMessages({
    subscribeStepIndicatorText: {
        id: "create-account.component.subscribe.Create an account - Step 3 of 3",
        defaultMessage: "Create an account - Step 3 of 3"
    } ,
    subscribeHeadingText: {
        id: "create-account.component.subscribe.Subscribe",
        defaultMessage: "Subscribe"
    },
    subscribeSuccessMessageText: {
        id: "create-account.component.subscribe.Your account is successfully created.",
        defaultMessage: "Your account is successfully created."
    },
    enrollTextMessagingSubHeaderText: {
        id: "create-account.component.subscribe.Enroll in text messaging",
        defaultMessage: "Enroll in text messaging"
    },
    enrollTextMessagingPara1Text: {
        id: "create-account.component.subscribe.enrollTextMessagingPara1",
        defaultMessage: "You can stay up to date with text messaging. We may text you policy notifications, billing notifications, or claims information. You can stop text messages at anytime."
    },
    enrollTextMessagingPara3Text: {
        id: "create-account.component.subscribe.enrollTextMessagingPara3",
        defaultMessage: "Enroll only if you are able to receive text messages at the phone number you provided."
    },
    enrollPaperlessSubHeaderText: {
        id: "create-account.component.subscribe.Enroll in paperless communications",
        defaultMessage: "Enroll in paperless communications"
    },
    enrollPaperlessPara1Text: {
        id: "create-account.component.subscribe.enrollPaperlessPara1Text",
        defaultMessage: "You can enroll in paperless delivery with access to your documents online or choose to receive them by U.S. Mail."
    }


});